var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDescription = function SvgDescription(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.4004C8.33137 11.4004 8.59961 11.6686 8.59961 12L8.58789 12.1211C8.53189 12.3944 8.2899 12.5996 8 12.5996H4C3.7101 12.5996 3.46811 12.3944 3.41211 12.1211L3.40039 12C3.40039 11.6686 3.66863 11.4004 4 11.4004H8Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.7334C12.3313 8.7334 12.5994 9.0019 12.5996 9.33301L12.5879 9.4541C12.5319 9.72744 12.2899 9.93262 12 9.93262H4C3.7101 9.93262 3.46811 9.72744 3.41211 9.4541L3.40039 9.33301C3.4006 9.0019 3.66867 8.7334 4 8.7334H12Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.06738C12.3314 6.06738 12.5996 6.33562 12.5996 6.66699C12.5994 6.9981 12.3313 7.2666 12 7.2666H4C3.66867 7.2666 3.4006 6.9981 3.40039 6.66699C3.40039 6.33562 3.66863 6.06738 4 6.06738H12Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.40039C12.3314 3.40039 12.5996 3.66863 12.5996 4L12.5879 4.12109C12.5319 4.39443 12.2899 4.59961 12 4.59961H4C3.7101 4.59961 3.46811 4.39443 3.41211 4.12109L3.40039 4C3.40039 3.66863 3.66863 3.40039 4 3.40039H12Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDescription);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "description.961e0d707adca5057170847bdc5d4cd7.svg";